// Formateo de moneda reutilizable
export function formatMoney(value, {
    locale = 'es-MX',
    currency = 'MXN',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    empty = '-',
} = {}) {
    if (value === null || value === '' || typeof value === 'undefined') return empty;
    const num = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(num)) return empty;
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(num);
}

// Versión fija MXN (más rápida)
export const moneyFmtMXN = new Intl.NumberFormat('es-MX', {
    style: 'currency', currency: 'MXN', minimumFractionDigits: 2, maximumFractionDigits: 2,
});

export const formatMoneyMXN = (v, empty = '-') => {
    if (v === null || v === '' || typeof v === 'undefined') return empty;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isNaN(n) ? empty : moneyFmtMXN.format(n);
};

// Prima mínima: null => 0.00
export const formatPremiumMin = (v) => formatMoneyMXN(v == null || v === '' ? 0 : v);

// Prima máxima: null => ∞
export const formatPremiumMax = (v, infinityLabel = '∞') =>
    (v == null || v === '' ? infinityLabel : formatMoneyMXN(v));
